import React from 'react'

import { DialogConfirmation } from 'app/KinerjaPSPegawaiPage/components/DialogConfirmation'

type TDialogPengembanganKompetensiConfirmationProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}
export const DialogPengembanganKompetensiConfirmation: React.FC<
  TDialogPengembanganKompetensiConfirmationProps
> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <DialogConfirmation
      isOpen={isOpen}
      autoFocus={false}
      returnFocus={false}
      size="sm"
      title="Simpan Pengembangan Kompetensi?"
      description="Setelah disimpan, Anda dapat ubah lagi sesuai kebutuhan atau langsung ajukan."
      ctaConfirm="Simpan"
      onClickConfirm={onConfirm}
      onClickCancel={onClose}
    />
  )
}
